import React, { useEffect } from "react";
import { ScrollTrigger } from "../animations/gsap.config";

import PortfolioHero from "../components/portfolio/PortfolioHero";
import FeaturedProjects from "../components/portfolio/FeaturedProjects";
import ProjectGrid from "../components/portfolio/ProjectGrid";
import ImpactMetrics from "../components/portfolio/ImpactMetrics";
import { useQuery } from "@tanstack/react-query";
import api from "../api/api";
import { useApp } from "../context/AppContext";
import SEO from "../components/SEO";

const Portfolio = () => {
  const { companyinfo } = useApp();
  /* Refresh ScrollTrigger after components mount */
  useEffect(() => {
    const timer = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 500);

    return () => clearTimeout(timer);
  }, []);
  const featuredlimit = 5;

  const {
    data: projects,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["projects", featuredlimit],
    queryFn: () => {
      const params = {
        limit: featuredlimit,
        isActive: true,
        is_featured: true,
      };

      // If category is not "All", apply it as a search metric matching your controller layer route setup

      return api
        .get("/api/projects/public", { params })
        .then((res) => res.data);
    },
    keepPreviousData: true, // Retains smooth transitions during layout rendering
  });
  const featuredProjects = projects?.projects;

  return (
    <>
      <SEO
        title="Our Projects | Transforming Data Into Impact"
        description="Explore our delivery maps of high-impact research and evaluation projects across the Horn of Africa partnering with UNHCR, UNICEF, IOM, and international NGOs."
        keywords={[
          "UNHCR evaluation dashboard",
          "Third-party monitoring case study",
          "Data impact assessments",
          "Horn of Africa development",
        ]}
        url="https://agoraconsulting-et.com/projects"
        image={`${companyinfo?.logo}`}
      />
      <main className="bg-white transition-colors duration-500">
        <PortfolioHero />
        {featuredProjects?.length > 0 && (
          <FeaturedProjects featuredProject={featuredProjects} />
        )}
        <ProjectGrid />
        <ImpactMetrics />
      </main>
    </>
  );
};

export default Portfolio;
